<template>
  <div class="recharge-client">
    <h1 class="title">选择充值平台</h1>
    <p class="desc">根据苹果公司规定，苹果设备和安卓设备中的账户余额不可互通</p>
    <ul class="type">
      <li @click="handleClick(2)" :class="{'checked': type === 2}">
        <span class="account"><img :src="type === 2 ? require('./images/iphone.png') : require('./images/iphone-n.png')" alt="">苹果账户</span>
        <span class="balance" v-if="type === 2">账户余额：{{balance}}知米</span>
      </li>
      <li :class="{'checked': type === 1}">
        <span class="account"> <img :src="type === 1 ? require('./images/android.png') : require('./images/android-n.png')" alt="">安卓账户</span>
        <span class="balance">此功能暂未上线</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['balance'],
  data () {
    return {
      type: 2
    }
  },
  methods: {
    handleClick (type) {
      this.type = type
      this.$emit('chooseClient', type)
    }
  }
}
</script>

<style lang="scss">
  @charset "UTF-8";
  @import "../../style/main";

  .recharge-client {
    padding: rem(40) rem(30);
    background-color: #fff;
    margin-bottom: rem(10);
    .title {
      font: {
        size: rem(32);
        weight: bolder;
      };
      line-height: rem(45);
      margin-bottom: rem(10);
      color: #333;
    }
    .desc {
      font: {
        size: rem(24);
      };
      color: #999999;
      line-height: rem(33);
      margin-bottom: rem(30);
    }
    .type {
      > li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #999999;
        padding: rem(20) rem(30);
        box-sizing: border-box;
        height: rem(90);
        border: rem(2) solid #999;
        border-radius: rem(10);
        font-size: rem(32);
        &:first-child {
          margin-bottom: rem(30);
        }
        .account {
          position: relative;
          padding-left: rem(60);
          > img {
            position: absolute;
            width: rem(36);
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .balance {
          font-size: rem(28);
        }
      }
      .checked {
        color: #F49000;
        border: rem(2) solid #F49000;
      }
    }
  }
</style>
